import React, { useState } from 'react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card } from "@/components/ui/card";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { useToast } from "@/hooks/use-toast";

interface AdminLoginProps {
  onLogin: (isAuthenticated: boolean) => void;
  adminPassword: string;
}

export const AdminLogin = ({ onLogin, adminPassword }: AdminLoginProps) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { toast } = useToast();

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === adminPassword) {
      onLogin(true);
      setError("");
      toast({
        title: "Success",
        description: "Welcome to the admin panel",
      });
    } else {
      setError("Invalid administrator password");
      toast({
        variant: "destructive",
        title: "Error",
        description: "Invalid administrator password",
      });
    }
  };

  return (
    <div className="container mx-auto p-6">
      <Card className="w-full max-w-md p-8 mx-auto">
        <h1 className="text-2xl font-bold text-center mb-6">Administrator Verification</h1>
        <form onSubmit={handleLogin} className="space-y-4">
          {error && (
            <Alert variant="destructive">
              <AlertDescription>{error}</AlertDescription>
            </Alert>
          )}
          <div className="space-y-2">
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter administrator password"
              className="w-full"
            />
          </div>
          <Button type="submit" className="w-full">
            Verify
          </Button>
        </form>
      </Card>
    </div>
  );
};
